import React, { useEffect, useState } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Box,
  VStack,
  HStack,
  Text,
  Icon,
  Button,
  Spinner,
  Switch,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  IconButton,
  Image,
} from '@chakra-ui/react';
import { FaCheck, FaStar } from 'react-icons/fa6';
import { loadPlans } from 'api/plans';
import { useContext } from 'react';
import { AccountContext } from '../../../AccountContext';
import { api } from 'api/api';
import Erro from '../../../../images/assets/erro.svg';
import { CloseIcon } from '@chakra-ui/icons';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { useNavigate } from 'react-router-dom';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function DrawerTrocarPlano({ disclosure, valor, simestralidade }) {
  const { isOpen, onClose } = disclosure;
  const [loading, setLoading] = useState(false);
  const [plano, setPlano] = useState(null);
  const [isAnual, setIsAnual] = useState(true);
  const [maxParcelas, setMaxParcelas] = useState(null);
  const { user, updateData } = useContext(AccountContext);
  const [error, setError] = useState(false);
  const [descricao_erro, setDescricao_erro] = useState('');
  const [showLoadingPlano, setShowLoadingPlano] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [trocaPlanoArgs, setTrocaPlanoArgs] = useState(null);

  useEffect(() => {
    async function fetchPlano() {
      setLoading(true);
      try {
        const data = await loadPlans();
        let planoEscolhido = null;
        if (user.id_plano === 29) {
          planoEscolhido = data.find((p) => String(p.id) === '55');
        } else {
          planoEscolhido = data.find((p) => String(p.id) === '29');
        }
        if (planoEscolhido) {
          setPlano(planoEscolhido);
        }
        const allParcelas = data.flatMap((plano) => plano.parcelas || []);
        const maxParcelasValue = allParcelas.length > 0 ? Math.max(...allParcelas.map((p) => p.quantidade)) : null;
        setMaxParcelas(maxParcelasValue);
      } finally {
        setLoading(false);
      }
    }
    if (isOpen) fetchPlano();
  }, [isOpen, user.id_plano]);

  const parcelaAnual = plano?.parcelas?.find((p) => p.quantidade === 1) || null;
  const parcelaMensal = plano?.parcelas?.find((p) => p.quantidade === 12) || null;

  const navigate = useNavigate();

  async function fetchTrocarPlano(id, quantidade) {
    setShowErrorMsg(false);
    setError(false);
    setDescricao_erro('');
    setLoading(true);
    try {
      const res = await api(`${ENDPOINT}/pacientes/upgrade_downgrade`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          contrato_id: user.id_contrato,
          plano_id: id,
          parcelas: quantidade,
        }),
      });
      const resposta = await res.json();
      if (resposta.sucesso === true) {
        const updateResult = await updateData({
          id_cliente_deovita: user.id_cliente_deovita,
          id_contrato: resposta.novo_id_contrato || id, 
          username: user.username,
        });
        if (!updateResult.success) {
          setLoading(false);
          return;
        }
        localStorage.setItem('plano_trocado_sucesso', '1');
        setShowLoadingPlano(true);
        setLoading(false);
        disclosure.onClose();
        navigate('/dashboard');
      } else {
        disclosure.onClose();
        setShowLoadingPlano(false);
        setError(true);
        setDescricao_erro(resposta.mensagem || 'Erro ao trocar plano');
        setShowErrorMsg(true);
        setLoading(false);
      }
    } catch (error) {
      disclosure.onClose();
      setShowLoadingPlano(false);
      setError(true);
      setDescricao_erro(error?.message || String(error));
      setShowErrorMsg(true);
      setLoading(false);
    }
  }

  function handleTrocarPlanoClick(id, quantidade) {
    setTrocaPlanoArgs({ id, quantidade });
    if (user.id_plano === 29) {
      setShowWarningModal(true);
    } else {
      fetchTrocarPlano(id, quantidade);
    }
  }

  function handleConfirmTrocaPlano() {
    setShowWarningModal(false);
    if (trocaPlanoArgs) {
      fetchTrocarPlano(trocaPlanoArgs.id, trocaPlanoArgs.quantidade);
    }
  }

  if (loading) {
    return (
      <>
        <ChildHeader />
        <Box
          w="100vw"
          h="100vh"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bg="#FFF"
          zIndex={9999}
          position="fixed"
          top={0}
          left={0}
        >
          <Spinner size="xl" color="#EB8B2A" thickness="5px" mb={6} />
        </Box>
      </>
    );
  }

  const ErrorModal = (
    <Modal
      isOpen={showErrorMsg}
      onClose={() => {
        setShowErrorMsg(false);
        setShowLoadingPlano(false);
      }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxW="350px" borderRadius="2xl" p={0} overflow="hidden">
        <ModalBody p={0} textAlign="center">
          <Box pt={8} pb={2} px={6} display="flex" flexDirection="column" alignItems="center">
            <Image src={Erro} alt="Erro" w="80px" mb={2} />
            <Text color="#CB0000" fontWeight="bold" fontSize="xl" mb={2}>
              Não foi possível realizar a troca do seu plano
            </Text>
            <Text color="#CB0000" fontSize="md" mb={4}>
              {descricao_erro}
            </Text>
            <Button
              onClick={() => {
                setShowErrorMsg(false);
                setShowLoadingPlano(false);
              }}
              colorScheme="red"
              w="100%"
              borderRadius="full"
              mb={4}
            >
              Fechar
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );

  return (
    <>
      {ErrorModal}
      <Modal isOpen={showWarningModal} onClose={() => setShowWarningModal(false)} size={{ base: 'full', sm: 'md' }}>
        <ModalOverlay />

        <ModalContent
          maxH="90dvh"
          overflowY="auto"
          borderRadius={{ base: 'xl', sm: '2xl' }}
          mx={{ base: 3, sm: 'auto' }}
          my={{ base: 4, sm: 'auto' }}
          pt="env(safe-area-inset-top)"
          pb="env(safe-area-inset-bottom)"
        >
          <ModalHeader display="flex" justifyContent="space-between" alignItems="center" fontSize="md" fontWeight="bold" color="#616161">
            Troca de plano
            <IconButton aria-label="Fechar" icon={<CloseIcon />} size="sm" variant="ghost" onClick={() => setShowWarningModal(false)} />
          </ModalHeader>

          <ModalBody textAlign="center" px={6}>
            <Image src={Erro} mx="auto" mb={4} w="120px" />

            <Text fontWeight="bold" fontSize="lg" color="#616161" mb={2}>
              Atenção antes de continuar!
            </Text>

            <Text fontSize="sm" color="#616161" mb={4}>
              <Text as="span" fontWeight="bold">
                Você está prestes a trocar do Plano Família para o Plano Individual.
              </Text>{' '}
              Antes de seguir, é importante saber que os{' '}
              <Text as="span" fontWeight="bold">
                dependentes vinculados à sua assinatura perderão acesso ao benefício
              </Text>
              , já que o Plano Individual contempla apenas{' '}
              <Text as="span" fontWeight="bold">
                1 pet
              </Text>
              , enquanto o Plano Família inclui até{' '}
              <Text as="span" fontWeight="bold">
                4 dependentes + 1 pet.
              </Text>
            </Text>

            <Box border="1px solid #BEE6E3" borderRadius="lg" bg={'white'} p={4} mb={6}>
              <Text fontSize="sm" color="#4F9C9A">
                O{' '}
                <Text as="span" fontWeight="bold">
                  Plano Família
                </Text>{' '}
                garante mais cobertura, mais economia e todos os benefícios compartilhados entre você e quem você cuida.
                <br />
                Se quiser manter todos protegidos,{' '}
                <Text as="span" fontWeight="bold">
                  recomendamos continuar com o Plano Família.
                </Text>
              </Text>
            </Box>

            <Button w="100%" bg="#5AB2AE" color="white" borderRadius="full" size="lg" mb={3} onClick={() => setShowWarningModal(false)}>
              Manter Plano Família
            </Button>

            <Button w="100%" variant="ghost" color="#7A7A7A" onClick={handleConfirmTrocaPlano}>
              Continuar com troca
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} size="md">
        <DrawerOverlay />
        <DrawerContent borderTopRadius="2xl" maxH="100dvh" overflowY="auto" pb="env(safe-area-inset-bottom)">
          <Box w="50px" h="6px" bg="#E0E0E0" borderRadius="full" mx="auto" cursor="pointer" mt={4} onClick={onClose} />
          <DrawerHeader color="#585858" fontWeight="bold" textAlign="center">
            Deseja trocar seu plano?
          </DrawerHeader>
          <DrawerBody>
            {loading ? (
              <>
                <ChildHeader />
                <Box w="100%" textAlign="center" py={10}>
                  <Spinner />
                </Box>
              </>
            ) : plano ? (
              <>
                <Box w="100%" maxW="500px" mx="auto" p={2} borderRadius={10} border="1px solid #5AB2AE">
                  <Box w="100%" display="flex" justifyContent="center" mt={4}>
                    <HStack
                      borderRadius={'1em'}
                      p={2}
                      spacing="3px"
                      align={'center'}
                      alignItems={'center'}
                      bg="linear-gradient(180deg, #5AB2AE 0%, #2A918A 100%);"
                      color={'white'}
                      justifyContent="center"
                      w="80%"
                      mb={4}
                    >
                      <Text fontSize="sm" fontWeight="bold">
                        Plano Disponível Para Troca
                      </Text>
                    </HStack>
                  </Box>
                  {isAnual && (
                    <>
                      <Text fontSize={{ base: 'sm', sm: 'md' }} mt={2} color="#616161" textAlign={'center'} mb={4}>
                        Obtenha{' '}
                        <Text as="span" color="#5AB2AE" fontWeight="bold">
                          duas parcelas grátis
                        </Text>{' '}
                        <br /> assinando em {maxParcelas} no cartão
                      </Text>
                    </>
                  )}
                  <Box w="100%" display="flex" justifyContent="center" alignItems="center" mb={2}>
                    <Text color={!isAnual ? '#237973' : '#616161'} fontWeight="bold" mr={2}>
                      Mensal
                    </Text>
                    <Switch colorScheme="teal" isChecked={isAnual} onChange={() => setIsAnual((prev) => !prev)} size="lg" id="switch-anual" mx={2} />
                    <Text color={isAnual ? '#237973' : '#616161'} fontWeight="bold" ml={2}>
                      Anual
                    </Text>
                  </Box>

                  <Box border={`2px solid #EB8B2A`} borderRadius="20px" bg="#FFF5EC" p={5} boxShadow="sm">
                    <VStack align="start" spacing={4}>
                      {plano.recomendado && (
                        <Box w="100%" display="flex" justifyContent="center">
                          <HStack
                            borderRadius={'0.8em'}
                            p={2}
                            spacing="3px"
                            align={'center'}
                            alignItems={'center'}
                            bg="#EB8B2A"
                            color={'white'}
                            justifyContent="center"
                            w="50%"
                          >
                            <Icon as={FaStar} />
                            <Text fontSize="sm">Recomendado!</Text>
                          </HStack>
                        </Box>
                      )}
                      <Text fontWeight="bold" fontSize="1.2em" color="#EB8B2A">
                        Assinatura {plano.nome} ({isAnual ? 'Anual' : 'Mensal'})
                      </Text>

                      <Text fontSize="4xl" fontWeight="bold" color="#EB8B2A" display="flex" alignItems="center" gap={2}>
                        {isAnual
                          ? parcelaAnual && parcelaAnual.min_valor !== undefined
                            ? Number(parcelaAnual.min_valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                            : ''
                          : parcelaMensal && parcelaMensal.min_valor !== undefined
                            ? Number(parcelaMensal.min_valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                            : ''}
                        <Text as="span" fontSize="md" color="#6C6C6C">
                          {isAnual ? '/ano' : '/mês'}
                        </Text>
                      </Text>
                      <Box bg={'#FFFFFFB2'} p={4} borderRadius="12px" w="100%" border={'1px solid #EB8B2A'}>
                        <VStack align="start" spacing={3}>
                          {plano.beneficios
                            ? plano.beneficios.map((b, index) => (
                                <HStack key={index} align="start">
                                  <Icon as={FaCheck} color="#EB8B2A" mt={1} />
                                  <Text color="#3A3A3A">{b.descricao || b}</Text>
                                </HStack>
                              ))
                            : null}
                        </VStack>
                      </Box>
                      <Button
                        w="100%"
                        bg="#EB8B2A"
                        color="white"
                        borderRadius="full"
                        size="md"
                        mt={2}
                        onClick={() => handleTrocarPlanoClick(plano.id, isAnual ? 1 : 12)}
                        disabled={loading}
                      >
                        Fazer troca
                      </Button>
                    </VStack>
                  </Box>
                </Box>
                <Box w="100%" maxW="500px" mx="auto" p={2} borderRadius={10} border="1px solid #5AB2AE" mt={5}>
                  <Box w="100%" display="flex" justifyContent="center" mt={3}>
                    <HStack
                      borderRadius={'1em'}
                      p={2}
                      spacing="3px"
                      align={'center'}
                      alignItems={'center'}
                      bg="linear-gradient(90deg, #B5DDDC 0%, #E0E0E0 100%);"
                      color={'#616161'}
                      justifyContent="center"
                      mb={4}
                    >
                      <Text fontSize="sm" fontWeight="bold">
                        Seu Plano Atual
                      </Text>
                    </HStack>
                  </Box>
                  <Box bg={'#EEF7F7'} p={4} borderRadius="12px" w="100%">
                    <VStack align="start" spacing={3}>
                      <Text color="#5AB2AE" fontWeight="bold" fontSize="1em">
                        Assinatura Plano {String(user.descricao_plano).charAt(0).toUpperCase() + String(user.descricao_plano).slice(1).toLowerCase()}
                      </Text>
                      <Text color="#5AB2AE" fontWeight="bold" fontSize="1.3em">
                        {valor !== undefined && valor !== null ? Number(valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : ''} {simestralidade === 12 ? '/mês' : '/ano'}
                      </Text>
                    </VStack>

                    <Button color="white" bg="#5AB2AE" borderRadius="full" size="md" mt={2} w="100%" onClick={onClose}>
                      Manter meu plano
                    </Button>
                  </Box>
                </Box>
                <Box w="100%" display="flex" justifyContent="center" mt={2} mb={1}>
                  <Box
                    w={{ base: '100%', md: '70%', lg: '50%' }}
                    maxW="500px"
                    mx="auto"
                    bg="#f9f2e2"
                    p={2}
                    borderRadius="1.2em"
                    border="1px solid #eed29d"
                    textAlign="center"
                    boxShadow="0 2px 16px 0 rgba(44,44,44,0.10)"
                  >
                    <Text fontSize="sm" color="#616161" mt={1}>
                      O faturamento do seu novo plano será lançado no próximo mês
                    </Text>
                  </Box>
                </Box>
              </>
            ) : (
              <Text>Nenhum plano encontrado.</Text>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default DrawerTrocarPlano;
